// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"b81e7ec9","85":"03994ecc","116":"44eb902e","123":"c4265e27","387":"708d67ba","463":"7442e38f","620":"a3501d60"}[chunkId] + ".chunk.css";
};